module.exports = __webpack_public_path__ + "assets/edf418c4f2b2ee713084094107ad0d0e.png";